import { render, staticRenderFns } from "./ticketHedingDetail.vue?vue&type=template&id=8d14f064&scoped=true"
import script from "./ticketHedingDetail.vue?vue&type=script&lang=js"
export * from "./ticketHedingDetail.vue?vue&type=script&lang=js"
import style0 from "./ticketHedingDetail.vue?vue&type=style&index=0&id=8d14f064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d14f064",
  null
  
)

export default component.exports